import React from "react";
import { motion } from "framer-motion";
import {
  HtmlEditor,
  Toolbar,
  Inject,
  RichTextEditorComponent,
} from "@syncfusion/ej2-react-richtexteditor";
import ReactDOM from "react-dom";
import { ReactViewAdobe, previewFile } from 'react-adobe-embed';
import { clientId } from './SecureMesage';


const Jreturn  = [
  (props:{
   index:number, reply?: JSX.Element | null
  })=> {
   return(
     <motion.div
     key={props.index}
     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_0"
           />
         </a>
       </div>
       <div id="print_0">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                                                                             <a href="javascript:void(0);"> <img
                                                                                                 src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                                                                             </a>
                                                                                         </div>
                                                                                          */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Can you please let me
                       know when my health insurance will become active? I am
                       in the process of having this health insurance
                       reactivate with Amazon.com. Can you take action on your
                       end to ensure this is done by tomorrow?
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/04/2023</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </motion.div>
   )
  },

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

    ng-if="changeIndex[$index]"
     className="panel-collapse collapse detiledMsgView  in"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse '"
     style={{}}
   >
     <div className="panel-body ">
       <div className="col-xs-12 detailedMsg">
         <div className="col-xs-12 pad0 text-right padB15">
           <a href="">
             {" "}
             <img
               src="https://member.aetna.com/secure/member/images/print.png"
               alt="Print"
               className="printIcon"
               msg-print=""
               print-element-id="print_0"
             />
           </a>
         </div>
         <div id="print_0">
           {/* ng-click="printDiv('print_'+$index)" */}
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
             {/* <div
             className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
             ng-if="messageFolderType =='Inbox'"
             ng-show="messageType"
           > */}

             {/* <div className="col-md-12 col-xs-12"> */}
             {/**/}
             <div
               className="col-xs-12 user_msg_box"
               style={{ display: "none" }}
               ng-if="display($index)"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Dear Ziping:
                 <br />
                 <br />
                 Thank you for contacting us.
                 <br />
                 <br />
                 Your coverage has ended
                 <br />
                 Our records show your coverage through Amazon ended on
                 08/31/2022. <br />
                 <br />
                 We apologize for any confusion and inconvenience you are
                 experiencing with this issue. Unfortunately, Aetna is not
                 responsible for terminating or activating your account. This
                 information needs to come from your employer. <br />
                 <br />
                 Changes needed
                 <br />
                 Please contact your benefits office if you think this
                 information is incorrect. They can contact our Employer
                 Services department to make any needed changes. You can
                 contact the Employee Resource Center at 1-888-892-7180 (choose
                 option 6). Once they update your file, they will send
                 eligibility information to Aetna and we can update your
                 records. <br />
                 <br />
                 Again, please accept our apologies for any inconvenience this
                 has caused you. <br />
                 <br />
                 If you have questions, use the 'Contact Us' link on the member
                 website (to protect your confidential information). Or, you
                 can call us toll-free at the number listed on your ID card.
                 <br />
                 <br />
                 Sincerely,
                 <br />
                 Alyson S.
                 <br />
                 Aetna Internet Response Team
                 <br />
                 49601595
                 <br />
                 <br />
                 NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                 To view Aetna's privacy practices, please edit, copy and paste
                 this website into your browser:
                 https://www.aetna.com/legal-notices/privacy.html <br />
                 <br />
                 If you have questions about the Coronavirus, there are helpful
                 resources online at CVS.com or copying and pasting this
                 website into your browser:
                 <a
                   href="https://www.aetna.com/individuals-families/member-rights-resources/covid19.html"
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                 </a>
                 <br />
                 <br />
                 <br />
                 *NA TRAD - Member - East
                 <br />
                 <br />
                 <br />
                 <br />
                 Original Message Excluded:
                 <br />
                 -----------------------
                 <br />
                 Details of Complaint: Explanation: You have 2 day to respond
                 ...[Message clipped]
                 <br />
               </p>
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 {" "}
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
               style={{ display: "none" }}
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: Member Services</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       Your coverage has ended
                       <br />
                       Our records show your coverage through Amazon ended on
                       08/31/2022. <br />
                       <br />
                       We apologize for any confusion and inconvenience you are
                       experiencing with this issue. Unfortunately, Aetna is
                       not responsible for terminating or activating your
                       account. This information needs to come from your
                       employer. <br />
                       <br />
                       Changes needed
                       <br />
                       Please contact your benefits office if you think this
                       information is incorrect. They can contact our Employer
                       Services department to make any needed changes. You can
                       contact the Employee Resource Center at 1-888-892-7180
                       (choose option 6). Once they update your file, they will
                       send eligibility information to Aetna and we can update
                       your records. <br />
                       <br />
                       Again, please accept our apologies for any inconvenience
                       this has caused you. <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Alyson S.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       49601595
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/27/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div
             style={{
               display: "none",
             }}
             ng-repeat="smcMessage in inboxMsgDetails.smcMessageList"
           >
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 You have today, to activate my health insurance. If you fail
                 to activate it today, I will file a lawsuit against Aetna.
                 <br />
                 <br />
                 And I will win. Because it's you get sued, or I sue the
                 government, and unfortunately, the courts are part of the
                 government and I'm sure they would rather have you sued.{" "}
                 <br />
                 <br />
                 Don't play dumb with me.
                 https://ercaws.com/2022/12/26/reality-check-8-5-inc1274728-opened-re-%f0%9f%9a%80launch-selipsky-to-space-announcement/
                 <br />
                 <br />
                 This is a public record: https://www.amazon-erc.com
                 <br />
                 <br />
                 It doesn't matter if Amazon talks to you or not, you are the
                 health insurance, not Amazon.
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: ZIPING LIU</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       You have today, to activate my health insurance. If you
                       fail to activate it today, I will file a lawsuit against
                       Aetna.
                       <br />
                       <br />
                       And I will win. Because it's you get sued, or I sue the
                       government, and unfortunately, the courts are part of
                       the government and I'm sure they would rather have you
                       sued. <br />
                       <br />
                       Don't play dumb with me.
                       https://ercaws.com/2022/12/26/reality-check-8-5-inc1274728-opened-re-%f0%9f%9a%80launch-selipsky-to-space-announcement/
                       <br />
                       <br />
                       This is a public record: https://www.amazon-erc.com
                       <br />
                       <br />
                       It doesn't matter if Amazon talks to you or not, you are
                       the health insurance, not Amazon.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/27/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Dear Ziping:
                 <br />
                 <br />
                 Thank you for contacting us.
                 <br />
                 <br />
                 We apologize for the inconvenience. <br />
                 <br />
                 Your coverage is terminated because Amazon sent us a file to
                 do so.{" "}
                 <strong>
                   We did call Amazon, but they could not speak to us.
                 </strong>{" "}
                 You will need to call Amazon to see why they sent us a file to
                 terminate your coverage. <br />
                 <br />
                 If you have questions, use the 'Contact Us' link on the member
                 website (to protect your confidential information). Or, you
                 can call us toll-free at the number listed on your ID card.
                 <br />
                 <br />
                 Sincerely,
                 <br />
                 Latisha W.
                 <br />
                 Aetna Internet Response Team
                 <br />
                 49416629
                 <br />
                 <br />
                 NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                 To view Aetna's privacy practices, please edit, copy and paste
                 this website into your browser:
                 <a href="https://www.aetna.com/legal-notices/privacy.html">
                   https://www.aetna.com/legal-notices/privacy.html
                 </a>{" "}
                 <br />
                 <br />
                 If you have questions about the Coronavirus, there are helpful
                 resources online at CVS.com or copying and pasting this
                 website into your browser:
                 https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                 <br />
                 <br />
                 <br />
                 *NA Concierge - Member - West
                 <br />
                 <br />
                 <br />
                 <br />
                 Original Message Excluded:
                 <br />
                 -----------------------
                 <br />
               </p>
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 {" "}
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
               style={{
                 display: "none",
               }}
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: Member Services</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       We apologize for the inconvenience. <br />
                       <br />
                       Your coverage is terminated because Amazon sent us a
                       file to do so. We did call Amazon, but they could not
                       speak to us. You will need to call Amazon to see why
                       they sent us a file to terminate your coverage. <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Latisha W.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       49416629
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA Concierge - Member - West
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/05/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div
             style={{
               display: "none",
             }}
             ng-repeat="smcMessage in inboxMsgDetails.smcMessageList"
           >
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 "Our records show your coverage through Amazon ended on
                 05/31/2022."
                 <br />
                 <br />
                 Wrong, they ended on 08/31/2022 as stated by you earlier. They
                 ended on 05/31/2022 and that was done as an adverse action by
                 Amazon Legal in which they ended my health insurance during my
                 FMLA Medical Leave - this leave is valid and granted as
                 protected Federally by Marty Walsh. See
                 https://aboutamazon.me/fmla for the FMLA Documents, or
                 thefbi.us/fmla. So, you then reactivated my health insurance
                 on June 11th, 2022. You then deactivated it again on
                 08/31/2022. So now my health records in the database for other
                 places are now completely messed up because people don't have
                 health insurance companies usually doing this kind of idiocy.{" "}
                 <br />
                 <br />
                 You do realize the Attorney Generals of WA, DE, and TX are
                 looped in as well as the State of Texas University of Texas
                 school system? I am gathering stakeholders to help.
                 <br />
                 <br />
                 You better activate my health insurance right now. Either you
                 join and help, or be scoped as criminals. Choose one.
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: ZIPING LIU</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       "Our records show your coverage through Amazon ended on
                       05/31/2022."
                       <br />
                       <br />
                       Wrong, they ended on 08/31/2022 as stated by you
                       earlier. They ended on 05/31/2022 and that was done as
                       an adverse action by Amazon Legal in which they ended my
                       health insurance during my FMLA Medical Leave - this
                       leave is valid and granted as protected Federally by
                       Marty Walsh. See https://aboutamazon.me/fmla for the
                       FMLA Documents, or thefbi.us/fmla. So, you then
                       reactivated my health insurance on June 11th, 2022. You
                       then deactivated it again on 08/31/2022. So now my
                       health records in the database for other places are now
                       completely messed up because people don't have health
                       insurance companies usually doing this kind of idiocy.{" "}
                       <br />
                       <br />
                       You do realize the Attorney Generals of WA, DE, and TX
                       are looped in as well as the State of Texas University
                       of Texas school system? I am gathering stakeholders to
                       help.
                       <br />
                       <br />
                       You better activate my health insurance right now.
                       Either you join and help, or be scoped as criminals.
                       Choose one.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/02/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div
             style={{
               display: "none",
             }}
             ng-repeat="smcMessage in inboxMsgDetails.smcMessageList"
           >
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Dear Ziping:
                 <br />
                 <br />
                 Thank you for contacting us.
                 <br />
                 <br />
                 We received your request
                 <br />
                 Your complaint has been sent to the correct department for
                 handling.
                 <br />
                 <br />
                 Your coverage has ended
                 <br />
                 Our records show your coverage through Amazon ended on
                 05/31/2022. <br />
                 <br />
                 Changes needed
                 <br />
                 Please contact your Employee Resource Center at 1-888-892-7180
                 if you think this information is incorrect. They can contact
                 our Employer Services department to make any needed changes.
                 We are not responsible for the termination. <br />
                 <br />
                 If you have questions, use the 'Contact Us' link on the member
                 website (to protect your confidential information). Or, you
                 can call us toll-free at the number listed on your ID card.
                 <br />
                 <br />
                 Sincerely,
                 <br />
                 Alyson S.
                 <br />
                 Aetna Internet Response Team
                 <br />
                 49408613
                 <br />
                 <br />
                 NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                 To view Aetna's privacy practices, please edit, copy and paste
                 this website into your browser:
                 https://www.aetna.com/legal-notices/privacy.html <br />
                 <br />
                 If you have questions about the Coronavirus, there are helpful
                 resources online at CVS.com or copying and pasting this
                 website into your browser:
                 https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                 <br />
                 <br />
                 <br />
                 *NA Concierge - Member - East
                 <br />
                 <br />
                 <br />
                 <br />
                 Original Message Excluded:
                 <br />
                 -----------------------
                 <br />
               </p>
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 {" "}
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: Member Services</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       We received your request
                       <br />
                       Your complaint has been sent to the correct department
                       for handling.
                       <br />
                       <br />
                       Your coverage has ended
                       <br />
                       Our records show your coverage through Amazon ended on
                       05/31/2022. <br />
                       <br />
                       Changes needed
                       <br />
                       Please contact your Employee Resource Center at
                       1-888-892-7180 if you think this information is
                       incorrect. They can contact our Employer Services
                       department to make any needed changes. We are not
                       responsible for the termination. <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Alyson S.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       49408613
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA Concierge - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       ----------------------- Details of Complaint:
                       Explanation: You have 2 day to respond ...[Message
                       clipped]
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/02/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div
             style={{
               display: "none",
             }}
             ng-repeat="smcMessage in inboxMsgDetails.smcMessageList"
           >
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Details of Complaint: Explanation: You have 2 day to respond
                 ...[Message clipped]
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               style={{
                 display: "none",
               }}
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: ZIPING LIU</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: You have 2 day to
                       respond. <br />
                       <br />
                       You are required to activate my health plan right away.
                       I read your letter from Jensine P sent on 11-7. She
                       refers that the sponsor, in. my case Amazon, decides to
                       activate or deactivate health and that Aetna is not
                       liable. Unfortunately, this is a fallacy. You are liable
                       as a health insurance company to operate in compliance
                       with Federal Rules and Regulations. The obvious nature
                       of the wrongful posoitiong of Amazon to turn off any
                       health is not at all something to ignoreas a health
                       insuranc company that follows rules of the DOL such as
                       FMLA and so forth. <br />
                       <br />
                       Please respond as soon as you can. Note that if you
                       respond again with writing that states you cannot do
                       anything. You will also be then admitting that you are
                       compliant and joining Amazon Legal in corporate
                       retaliation against Ziping Liu.
                       <br />
                       <br />
                       Please see our latest releases here: ercaws.com
                       <br />
                       <br />
                       It is not at all normal to think that nothing wrong has
                       happened. <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>12/01/2022</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                                                     <img
                                                                                         src="images/Communication_center_icons/User-1.png"
                                                                                         alt="" class="padL15">
                                                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)
},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

    ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_3"
           />
         </a>
       </div>
       <div id="print_3">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       You have 2 day to respond. <br />
                       <br />
                       You are required to activate my health plan right away.
                       I read your letter from Jensine P sent on 11-7. She
                       refers that the sponsor, in. my case Amazon, decides to
                       activate or deactivate health and that Aetna is not
                       liable. Unfortunately, this is a fallacy. You are liable
                       as a health insurance company to operate in compliance
                       with Federal Rules and Regulations. The obvious nature
                       of the wrongful positing of Amazon to turn off any
                       health is not at all something to ignores a health
                       insurance company that follows rules of the DOL such as
                       FMLA and so forth. <br />
                       <br />
                       Please respond as soon as you can. Note that if you
                       respond again with writing that states you cannot do
                       anything. You will also be then admitting that you are
                       compliant and joining Amazon Legal in corporate
                       retaliation against Ziping Liu.
                       <br />
                       <br />
                       Please see aboutamazon.me/greed for more info.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                     <div ng-if="smcMessage.attachments.length">
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           23andMe Ancestry Book - Part 1 of 2_encrypted_.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                     </div>
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 12/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping Liu:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       We received your request
                       <br />
                       Your complaint has been sent to the correct department
                       for handling.
                       <br />
                       <br />
                       Your coverage has ended
                       <br />
                       Our records show your coverage through Amazon ended on
                       08/31/2022, we are not responsible for the termination.
                       <br />
                       <br />
                       Please contact your benefits office if you think this
                       information is incorrect. They can contact our Employer
                       Services department to make any needed changes.
                       <br />
                       <br />
                       You may contact Amazon at 1-866-644-2696 regarding your
                       eligibility issue.
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Britani H.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48999877
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - West
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 10/11/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: I am not at all happy
                       to see you ending my medical coverage in October, while
                       I am in the middle of getting medical treatments with
                       GreensBrookTMS.
                       <br />
                       <br />
                       Your Medical Company should be more than aware of the
                       ongoing circumstances involving Amazon, the non-standing
                       employer at this point, and Ziping Liu, the current
                       employee which is being corporate retaliated against.
                       <br />
                       <br />I expect you to activate my health services
                       immediately. <br />
                       <br />I have already filed a grievance ticket here:
                       <br />
                       <br />
                       https://www.amazon-erc.com/amazonbenefits/resourcesforliving/
                       <br />
                       <br />
                       If you are not up to speed with what's going on read
                       here:
                       <br />
                       <br />
                       https://liu.academy/stakeholder/letter
                       <br />
                       <br />
                       You should be more than happy to address the concerns.
                       You need to escalate this up to your SIU department and
                       get my health insurance activated. Why are we doing
                       something we already did in May, and June. <br />
                       <br />
                       And why did you allow this to happen Aetna?
                       <br />
                       <br />
                       We have a press site now: https://amazonliu.com
                       <br />
                       <br />
                       Traffic is at 50K visitors a day. Don't be on the wrong
                       side of press.
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 10/06/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)
}
   ,

   (props:{
     index:number, reply?: JSX.Element | null
   }) => {
     return(
       <div
     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_4"
           />
         </a>
       </div>
       <div id="print_4">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: You have 2 day to
                       respond. <br />
                       <br />
                       You are required to activate my health plan right away.
                       I read your letter from Jensine P sent on 11-7. She
                       refers that the sponsor, in. my case Amazon, decides to
                       activate or deactivate health and that Aetna is not
                       liable. Unfortunately, this is a fallacy. You are liable
                       as a health insurance company to operate in compliance
                       with Federal Rules and Regulations. The obvious nature
                       of the wrongful posoitiong of Amazon to turn off any
                       health is not at all something to ignoreas a health
                       insuranc company that follows rules of the DOL such as
                       FMLA and so forth. <br />
                       <br />
                       Please respond as soon as you can. Note that if you
                       respond again with writing that states you cannot do
                       anything. You will also be then admitting that you are
                       compliant and joining Amazon Legal in corporate
                       retaliation against Ziping Liu.
                       <br />
                       <br />
                       Please see our latest releases here: ercaws.com
                       <br />
                       <br />
                       It is not at all normal to think that nothing wrong has
                       happened. <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 12/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>
     )
   },

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_5"
           />
         </a>
       </div>
       <div id="print_5">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                                                                             <a href="javascript:void(0);"> <img
                                                                                                 src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                                                                             </a>
                                                                                         </div>
                                                                                          */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: I am not at all happy
                       to see you ending my medical coverage in October, while
                       I am in the middle of getting medical treatments with
                       GreensBrookTMS.
                       <br />
                       <br />
                       Your Medical Company should be more than aware of the
                       ongoing circumstances involving Amazon, the non-standing
                       employer at this point, and Ziping Liu, the current
                       employee which is being corporate retaliated against.
                       <br />
                       <br />I expect you to activate my health services
                       immediately. <br />
                       <br />I have already filed a grievance ticket here:
                       <br />
                       <br />
                       https://www.amazon-erc.com/amazonbenefits/resourcesforliving/
                       <br />
                       <br />
                       If you are not up to speed with what's going on read
                       here:
                       <br />
                       <br />
                       https://liu.academy/stakeholder/letter
                       <br />
                       <br />
                       You should be more than happy to address the concerns.
                       You need to escalate this up to your SIU department and
                       get my health insurance activated. Why are we doing
                       something we already did in May, and June. <br />
                       <br />
                       And why did you allow this to happen Aetna?
                       <br />
                       <br />
                       We have a press site now: https://amazonliu.com
                       <br />
                       <br />
                       Traffic is at 50K visitors a day. Don't be on the wrong
                       side of press.
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 10/06/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_6"
           />
         </a>
       </div>
       <div id="print_6">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Thank you. <br />
                       <br />
                       As you can tell, Amazon Legal, has caused a huge
                       violation.
                       <br />
                       <br />
                       At a incorporation standing frame of sabotage of itself.
                       <br />
                       <br />
                       Please use this as a case study for how to not run a
                       corporation,.
                       <br />
                       <br />
                       https://adamselipsky.com
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 07/27/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping Liu:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       We received your request
                       <br />
                       Your complaint has been sent to the correct department
                       for handling.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Lataunya M.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48087566
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/02/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping Liu:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       You may contact Amazon at 866-644-2696 regarding your
                       eligibility issue.
                       <br />
                       <br />
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Jeffrey S.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48087304
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/02/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Aetna Record of Murder.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                     <div ng-if="smcMessage.attachments.length">
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           AentaEvidence.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                     </div>
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       You aren't able to assist in activating my insurance?
                       Even though I got paid on May 31st, deposited into my
                       bank account: thereby financial writing in proof I'm
                       still employed at Amazon, moreover the other documents
                       already shown?
                       <br />
                       <br />
                       So you agree with seeing Federal Laws being broken then:
                       This is confirmation of such, in writing. And you are
                       complicit with my ongoing murder, in writing as well.
                       <br />
                       <br />
                       Thank you Aetna, for showing your true intentions and
                       colors as a health insurance company today., and last
                       month for doing absolutely nothing for the sake of my
                       Health: <br />
                       <br />
                       TO: AETNA ASSOCIATES AND AMAZON EXECUTIVE ASSOCIATES,
                       INCLUDING ANDY JASSY&nbsp;AJASSY@AMAZON.COM, AND ADAM
                       SELIPSKY, CURRENT CEO'S
                       OF&nbsp;AMAZON.COM&nbsp;AND&nbsp;AWS.AMAZON.COM&nbsp;BY
                       FORMALITY ONLY.&nbsp;&nbsp;ATTENTION: NOTICE OF MURDER
                       IN PROGRESS BY THE ADDRESSED, AGGRESSED TOWARDS ZIPING
                       LIU.&nbsp;
                       <br />
                       <br />
                       <br />
                       MESSAGE: LOOK AT THIS, I CANT EVEN GO PICK UP MY MONTHLY
                       PRESCRIPTION NOW TOO. THIS IS MURDER IN PROGRESS. GUESS
                       WHAT HAPPENS WHEN I JUST SUDDENLY STOP TAKING
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Liu Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       Your coverage status
                       <br />
                       Your employer Amazon.com Services, INC. has terminated
                       your health plan with Aetna, we were not responsible for
                       this termination and cannot assist. Please contact your
                       human resources or benefits office to verify why your
                       coverage has ended.
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Ezra W.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48085354
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Aetna,
                       <br />
                       <br />
                       I'm not sure why my insurance card and number isn't
                       currently working. Please update my insurance card
                       policy appropriately to resolve this matter. I'm due for
                       a medication refill today - i refill my medications each
                       month; however, I am unable to pick up my medications
                       until the insurance card works. You fast resolution is
                       appreciated since I will be without my medications until
                       this matter of insurance is resolved.
                       <br />
                       <br />
                       Thanks,
                       <br />
                       <br />
                       Ziping Liu
                       <br />
                       Policy iD: w264012314
                       <br />
                       RXBIN 003858
                       <br />
                       RXPCN A4
                       <br />
                       RXGRP AMAZON1
                       <br />
                       <br />
                       I'm on FMLA and LEGAL PROTECTION LEAVEV until DEC 2022,
                       WITH OFFICIAL CONFIRM OF FIRST STAGE OF FMLA LEAVE UNTIL
                       JUNE11 GIVEN IN WRITING BY AMAZON DLS. PLEASE DO NOT
                       COMMIT VIOLATIONS OF FEDERAL LAWS. IMMEDIATE ACTION
                       REQUIRED. DAMAGES NOW SEALED IN WRITING BY AETNA&gt;
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_7"
           />
         </a>
       </div>
       <div id="print_7">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Aetna Record of Murder.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                     <div ng-if="smcMessage.attachments.length">
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           AentaEvidence.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                     </div>
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       You aren't able to assist in activating my insurance?
                       Even though I got paid on May 31st, deposited into my
                       bank account: thereby financial writing in proof I'm
                       still employed at Amazon, moreover the other documents
                       already shown?
                       <br />
                       <br />
                       So you agree with seeing Federal Laws being broken then:
                       This is confirmation of such, in writing. And you are
                       complicit with my ongoing murder, in writing as well.
                       <br />
                       <br />
                       Thank you Aetna, for showing your true intentions and
                       colors as a health insurance company today., and last
                       month for doing absolutely nothing for the sake of my
                       Health: <br />
                       <br />
                       TO: AETNA ASSOCIATES AND AMAZON EXECUTIVE ASSOCIATES,
                       INCLUDING ANDY JASSY&nbsp;AJASSY@AMAZON.COM, AND ADAM
                       SELIPSKY, CURRENT CEO'S
                       OF&nbsp;AMAZON.COM&nbsp;AND&nbsp;AWS.AMAZON.COM&nbsp;BY
                       FORMALITY ONLY.&nbsp;&nbsp;ATTENTION: NOTICE OF MURDER
                       IN PROGRESS BY THE ADDRESSED, AGGRESSED TOWARDS ZIPING
                       LIU.&nbsp;
                       <br />
                       <br />
                       <br />
                       MESSAGE: LOOK AT THIS, I CANT EVEN GO PICK UP MY MONTHLY
                       PRESCRIPTION NOW TOO. THIS IS MURDER IN PROGRESS. GUESS
                       WHAT HAPPENS WHEN I JUST SUDDENLY STOP TAKING
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   <div className="col-xs-12 pad0 text-right">
                     <a href="javascript:void(0);">
                       {" "}
                       <img
                         src="https://member.aetna.com/secure/member/images/print.png"
                         alt=""
                         className="printIcon"
                       />
                     </a>
                   </div>

                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Liu Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       Your coverage status
                       <br />
                       Your employer Amazon.com Services, INC. has terminated
                       your health plan with Aetna, we were not responsible for
                       this termination and cannot assist. Please contact your
                       human resources or benefits office to verify why your
                       coverage has ended.
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Ezra W.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48085354
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Aetna,
                       <br />
                       <br />
                       I'm not sure why my insurance card and number isn't
                       currently working. Please update my insurance card
                       policy appropriately to resolve this matter. I'm due for
                       a medication refill today - i refill my medications each
                       month; however, I am unable to pick up my medications
                       until the insurance card works. You fast resolution is
                       appreciated since I will be without my medications until
                       this matter of insurance is resolved.
                       <br />
                       <br />
                       Thanks,
                       <br />
                       <br />
                       Ziping Liu
                       <br />
                       Policy iD: w264012314
                       <br />
                       RXBIN 003858
                       <br />
                       RXPCN A4
                       <br />
                       RXGRP AMAZON1
                       <br />
                       <br />
                       I'm on FMLA and LEGAL PROTECTION LEAVEV until DEC 2022,
                       WITH OFFICIAL CONFIRM OF FIRST STAGE OF FMLA LEAVE UNTIL
                       JUNE11 GIVEN IN WRITING BY AMAZON DLS. PLEASE DO NOT
                       COMMIT VIOLATIONS OF FEDERAL LAWS. IMMEDIATE ACTION
                       REQUIRED. DAMAGES NOW SEALED IN WRITING BY AETNA&gt;
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_8"
           />
         </a>
       </div>
       <div id="print_8">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       You aren't able to assist in activating my insurance?
                       Even though I got paid on May 31st, deposited into my
                       bank account: thereby financial writing in proof I'm
                       still employed at Amazon, moreover the other documents
                       already shown?
                       <br />
                       <br />
                       So you agree with seeing Federal Laws being broken then:
                       This is confirmation of such, in writing. And you are
                       complicit with my ongoing murder, in writing as well.
                       <br />
                       <br />
                       Thank you Aetna, for showing your true intentions and
                       colors as a health insurance company today., and last
                       month for doing absolutely nothing for the sake of my
                       Health: <br />
                       <br />
                       TO: AETNA ASSOCIATES AND AMAZON EXECUTIVE ASSOCIATES,
                       INCLUDING ANDY JASSY&nbsp;AJASSY@AMAZON.COM, AND ADAM
                       SELIPSKY, CURRENT CEO'S
                       OF&nbsp;AMAZON.COM&nbsp;AND&nbsp;AWS.AMAZON.COM&nbsp;BY
                       FORMALITY ONLY.&nbsp;&nbsp;ATTENTION: NOTICE OF MURDER
                       IN PROGRESS BY THE ADDRESSED, AGGRESSED TOWARDS ZIPING
                       LIU.&nbsp;
                       <br />
                       <br />
                       <br />
                       MESSAGE: LOOK AT THIS, I CANT EVEN GO PICK UP MY MONTHLY
                       PRESCRIPTION NOW TOO. THIS IS MURDER IN PROGRESS. GUESS
                       WHAT HAPPENS WHEN I JUST SUDDENLY STOP TAKING
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Liu Ziping:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       Your coverage status
                       <br />
                       Your employer Amazon.com Services, INC. has terminated
                       your health plan with Aetna, we were not responsible for
                       this termination and cannot assist. Please contact your
                       human resources or benefits office to verify why your
                       coverage has ended.
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Ezra W.
                       <br />
                       Aetna Internet Response Team
                       <br />
                       48085354
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA TRAD - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: Member Services</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Aetna,
                       <br />
                       <br />
                       I'm not sure why my insurance card and number isn't
                       currently working. Please update my insurance card
                       policy appropriately to resolve this matter. I'm due for
                       a medication refill today - i refill my medications each
                       month; however, I am unable to pick up my medications
                       until the insurance card works. You fast resolution is
                       appreciated since I will be without my medications until
                       this matter of insurance is resolved.
                       <br />
                       <br />
                       Thanks,
                       <br />
                       <br />
                       Ziping Liu
                       <br />
                       Policy iD: w264012314
                       <br />
                       RXBIN 003858
                       <br />
                       RXPCN A4
                       <br />
                       RXGRP AMAZON1
                       <br />
                       <br />
                       I'm on FMLA and LEGAL PROTECTION LEAVEV until DEC 2022,
                       WITH OFFICIAL CONFIRM OF FIRST STAGE OF FMLA LEAVE UNTIL
                       JUNE11 GIVEN IN WRITING BY AMAZON DLS. PLEASE DO NOT
                       COMMIT VIOLATIONS OF FEDERAL LAWS. IMMEDIATE ACTION
                       REQUIRED. DAMAGES NOW SEALED IN WRITING BY AETNA&gt;
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_9"
           />
         </a>
       </div>
       <div id="print_9">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Aetna,
                       <br />
                       <br />
                       I'm not sure why my insurance card and number isn't
                       currently working. Please update my insurance card
                       policy appropriately to resolve this matter. I'm due for
                       a medication refill today - i refill my medications each
                       month; however, I am unable to pick up my medications
                       until the insurance card works. You fast resolution is
                       appreciated since I will be without my medications until
                       this matter of insurance is resolved.
                       <br />
                       <br />
                       Thanks,
                       <br />
                       <br />
                       Ziping Liu
                       <br />
                       Policy iD: w264012314
                       <br />
                       RXBIN 003858
                       <br />
                       RXPCN A4
                       <br />
                       RXGRP AMAZON1
                       <br />
                       <br />
                       I'm on FMLA and LEGAL PROTECTION LEAVEV until DEC 2022,
                       WITH OFFICIAL CONFIRM OF FIRST STAGE OF FMLA LEAVE UNTIL
                       JUNE11 GIVEN IN WRITING BY AMAZON DLS. PLEASE DO NOT
                       COMMIT VIOLATIONS OF FEDERAL LAWS. IMMEDIATE ACTION
                       REQUIRED. DAMAGES NOW SEALED IN WRITING BY AETNA&gt;
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 06/01/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_10"
           />
         </a>
       </div>
       <div id="print_10">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                         <a href="javascript:void(0);"> <img
                                           src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                         </a>
                                       </div>
                                        */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Hi Aetna,
                       <br />
                       <br />I don't trust doctors.
                       <br />
                       <br />
                       They overbill.
                       <br />
                       <br />
                       Please send me their full list of charges for the bill
                       to my plan, and I'll advocate on your behalf to tell
                       them you are over-billing aetna.
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 04/26/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},

(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

     ng-if="changeIndex[$index]"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse'"
     className="panel-collapse collapse detiledMsgView in"
     style={{}}
   >
     <div className="panel-body">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="https://member.aetna.com/secure/member/images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_11"
           />
         </a>
       </div>
       <div id="print_11">
         <div className="col-xs-12 detailedMsg">
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList track by $index">
             {/**/}
             {/**/}
             {/**/}
             <div
               className="user2_msg_content row"
               ng-if="messageFolderType =='Sent'"
             >
               <div className="col-md-2 col-xs-3 user_img">
                 <img
                   src="https://member.aetna.com/secure/member/images/Communication_center_icons/User-2.png"
                   alt=""
                   className="padR15"
                 />
               </div>
               <div className="col-md-12 col-xs-12">
                 {/**/}
                 <div
                   className="col-xs-12 user_msg_box"
                   ng-if="display($index)"
                 >
                   {/* <div class="col-xs-12 pad0 text-right">
                                                                                             <a href="javascript:void(0);"> <img
                                                                                                 src="https://member.aetna.com/secure/member/images/print.png" alt="" class="printIcon">
                                                                                             </a>
                                                                                         </div>
                                                                                          */}
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong />
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Hi,
                       <br />
                       <br />
                       Just some medical records. My doctors keep losing them.
                       So I save them myself.
                       <br />
                       <br />I have a hippa compliant fax number I use for my
                       personal medical documents, efax gave me one because
                       they felt sorry for me:
                       <br />
                       12024780901
                       <br />
                       <br />
                       Thanks!
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                     <div ng-if="smcMessage.attachments.length">
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           at_risk_genetics.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           lab_report_2021.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           pyschology_report.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           genetics.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                       <p
                         className="attachments"
                         style={{ marginBottom: 5 }}
                         ng-repeat="attach in smcMessage.attachments"
                       >
                         <a
                           href=""
                           ng-click="OpenNewPage(smcMessage.smcMessageID,attach)"
                         >
                           <img
                             src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                             alt=""
                             className="padR15"
                             ng-show="isPDFFile(attach.name)"
                           />
                           Passport color.pdf
                         </a>{" "}
                         {/**/}
                       </p>
                       {/**/}
                     </div>
                     {/**/}
                   </div>
                   <span style={{ textAlign: "right" }} />
                 </div>
                 {/**/}
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-left">
                     <span>From: ZIPING LIU</span>
                   </p>
                   <p className="text-left">
                     <span>Sent: 04/13/2022</span>
                   </p>
                 </div>
               </div>
               <div className="col-md-2 text-left" />
             </div>
             {/**/}
           </div>
           {/**/}
         </div>
       </div>
     </div>
   </div>)},
(props:{
index:number, reply?: JSX.Element | null}) => {return(<div key={props.index}

    ng-if="changeIndex[$index]"
     className="panel-collapse collapse detiledMsgView  in"
     ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse '"
     style={{}}
   >
     <div className="panel-body ">
       <div className="col-xs-12 detailedMsg">
         <div className="col-xs-12 pad0 text-right padB15">
           <a href="">
             {" "}
             <img
               src="images/print.png"
               alt="Print"
               className="printIcon"
               msg-print=""
               print-element-id="print_0"
             />
           </a>
         </div>
         <div id="print_0">
           {/* ng-click="printDiv('print_'+$index)" */}
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Dear Ziping Liu:
                 <br />
                 <br />
                 Thank you for contacting us.
                 <br />
                 <br />
                 Your coverage has ended <br />
                 Our records show your coverage through Amazon.Com Services,
                 Inc became effective from 12/18/2020 and ended on 08/31/2022.
                 Our records show that your coverage was not reinstated until
                 06/06/2023. <br /> <br />
                 Changes needed <br />
                 Please contact your benefits office if you think this
                 information is incorrect. You can reach My HR Live Support at
                 1-800-621-8041. They can contact our Employer Services
                 department to make any needed changes.
                 <br />
                 <br />
                 If there is anything else that we can assist you with, please
                 let us know. We are happy to help you!
                 <br />
                 <br />
                 If you have questions, use the 'Contact Us' link on the member
                 website (to protect your confidential information). Or, you
                 can call us toll-free at the number listed on your ID card.
                 <br />
                 <br />
                 Sincerely,
                 <br />
                 Suraj N<br />
                 Aetna Internet Response Team
                 <br />
                 50898500
                 <br />
                 <br />
                 NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                 To view Aetna's privacy practices, please edit, copy and paste
                 this website into your browser:
                 https://www.aetna.com/legal-notices/privacy.html <br />
                 <br />
                 If you have questions about the Coronavirus, there are helpful
                 resources online at CVS.com or copying and pasting this
                 website into your browser:
                 https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                 <br />
                 <br />
                 <br />
                 *NA Concierge - Member - East
                 <br />
                 <br />
                 <br />
                 <br />
                 Original Message Excluded:
                 <br />
                 -----------------------
                 <br />
               </p>
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 {" "}
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: Member Services</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Dear Ziping Liu:
                       <br />
                       <br />
                       Thank you for contacting us.
                       <br />
                       <br />
                       Your coverage has ended <br />
                       Our records show your coverage through Amazon.Com
                       Services, Inc became effective from 12/18/2020 and ended
                       on 08/31/2022. Our records show that your coverage was
                       not reinstated until 06/06/2023. <br /> <br />
                       Changes needed <br />
                       Please contact your benefits office if you think this
                       information is incorrect. You can reach My HR Live
                       Support at 1-800-621-8041. They can contact our Employer
                       Services department to make any needed changes.
                       <br />
                       <br />
                       If there is anything else that we can assist you with,
                       please let us know. We are happy to help you!
                       <br />
                       <br />
                       If you have questions, use the 'Contact Us' link on the
                       member website (to protect your confidential
                       information). Or, you can call us toll-free at the
                       number listed on your ID card.
                       <br />
                       <br />
                       Sincerely,
                       <br />
                       Suraj N<br />
                       Aetna Internet Response Team
                       <br />
                       50898500
                       <br />
                       <br />
                       NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                       To view Aetna's privacy practices, please edit, copy and
                       paste this website into your browser:
                       https://www.aetna.com/legal-notices/privacy.html <br />
                       <br />
                       If you have questions about the Coronavirus, there are
                       helpful resources online at CVS.com or copying and
                       pasting this website into your browser:
                       https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                       <br />
                       <br />
                       <br />
                       *NA Concierge - Member - East
                       <br />
                       <br />
                       <br />
                       <br />
                       Original Message Excluded:
                       <br />
                       -----------------------
                       <br />
                     </p>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       {" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>06/06/2023</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                   <img
                                                     src="images/Communication_center_icons/User-1.png"
                                                     alt="" class="padL15">
                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
           <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
             {/**/}
             <div
               className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
               ng-if="messageFolderType =='Inbox'"
               ng-show="messageType"
             >
               {/**/}
               <p
                 ng-repeat="body in smcMessage.bodies"
                 ng-bind-html="body.content | newlines"
                 className="healthReminder"
               >
                 Details of Complaint: Explanation: Can you please let me know
                 when my health insurance will become active? I am in the
                 process of having this health insurance reactivate with
                 Amazon.com. Can you take action on your end to ensure this is
                 done by tomorrow?
                 <br />
                 Resolution Actions: Attempt to resolve the situation:{" "}
               </p>
               {/**/}
             </div>
             {/**/}
             {/**/}
             <div
               className="user1_msg_content row"
               ng-if="messageFolderType =='Inbox'"
               ng-hide="messageType"
             >
               {/* commented as part of smcchanges Team B */}
               {/* <div class="col-md-2 text-right"></div> */}
               <div className="col-xs-12 pad0 padB15">
                 <div className="col-xs-12 user_msg_box">
                   <div className="col-xs-12 padL0 padR0 padB15">
                     <strong>From: ZIPING LIU</strong>
                     {/**/}
                     <p
                       ng-repeat="body in smcMessage.bodies"
                       ng-bind-html="body.content | newlines"
                     >
                       Details of Complaint: Explanation: Can you please let me
                       know when my health insurance will become active? I am
                       in the process of having this health insurance
                       reactivate with Amazon.com. Can you take action on your
                       end to ensure this is done by tomorrow?
                       <br />
                       Resolution Actions: Attempt to resolve the situation:{" "}
                     </p>
                     {/**/}
                     {/**/}
                     <div style={{ marginTop: "15px !important" }} />
                     {/**/}
                   </div>
                 </div>
                 <div className="col-xs-12 pad0 padT5">
                   <p className="text-right">
                     <span>06/04/2023</span>
                   </p>
                 </div>
               </div>
               {/* Removed as part of SMC changes */}
               {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                                   <img
                                                     src="images/Communication_center_icons/User-1.png"
                                                     alt="" class="padL15">
                                                 </div> */}
             </div>
             {/**/}
             {/**/}
           </div>
           {/**/}
         </div>
         <div
           className="modal fade contact-modal"
           id="contact-popup-reply"
           role="dialog"
           aria-labelledby="contact-confirmation"
         >
           <div className="modal-dialog">
             {/* Modal content*/}
             <div className="modal-content">
               <div className="modal-header text-center">
                 <h4 className="modal-title" id="contact-confirmation">
                   Alert
                 </h4>
               </div>
               <div className="modal-body" id="popUpBody">
                 <p
                   ng-bind-html="popUpMessage"
                   style={{ overflowWrap: "break-word" }}
                 >
                   Upload failed. Please try again. If the issue persists,
                   contact member services.
                 </p>
               </div>
               <div className="modal-footer">
                 <div>
                   <button
                     type="submit"
                     className="primaryBtn"
                     ng-click="popUpCloseReply('Ok')"
                   >
                     Yes
                   </button>
                   <button
                     className="cancelBtn"
                     type="button"
                     style={{ marginLeft: 15 }}
                     ng-click="popUpCloseReply('')"
                   >
                     No
                   </button>
                 </div>
               </div>
               <button type="button" className="close" data-dismiss="modal">
                 <img
                   src="images/close.png"
                   className="close"
                   alt="Close"
                   ng-click="popUpCloseReply('')"
                 />
               </button>
             </div>
           </div>
         </div>
         <div className="col-xs-12 text-right pad0" ng-show="isReply">
           <button
             className="primaryBtn msgActionBtn"
             type="button"
             ng-click="replyShow()"
           >
             Reply
           </button>
         </div>
         <div
           className="col-xs-12 padT15 submsgContent ng-pristine ng-valid ng-valid-maxlength ng-hide"
           ng-form="replyForm"
           ng-show="!(isReply)"
         >
           <div className="col-xs-12 pad0 form-group">
             <label htmlFor="subMsg" className="control-label sr-only">
               New sub message
             </label>

             <div ng-show="sendChk" className="ng-hide">
               <span className="error">Message cannot be blank.</span>
             </div>
             <div className="col-xs-12 pad0">
               {/**/}
               <div
                 className="cont-cliamsrt uploadAttachment row"
                 ng-if="isFileUpload"
               >
                 <div className="form-group clearfix form-group clearfix  ">
                   <div className="col-sm-4 ">
                     <label
                       htmlFor="fileuploadlist"
                       className="paddlr30 btn anchor bold btn-default btn-file"
                       ng-class="{ 'btn-file': (((uploadFiles.length)<5) && (totalSizeFile<5242880)),'btn-file-disable':(((uploadFiles.length)>=5) || (totalSizeFile>5242880)||(fileCount>=5))}"
                     >
                       Upload attachment(s)
                       <input
                         type="file"
                         id="fileuploadlist"
                         name="Upload attachment(s)"
                         ng-disabled="(((uploadFiles.length)==5) || (totalSizeFile>5242880))"
                         data-multiple="true"
                         custom-on-change="fileslistdemo"
                         style={{ display: "none" }}
                       />
                     </label>
                   </div>
                   <label className="col-sm-8">
                     {" "}
                     <span>Add up to 5 files, total of 5 MB</span>
                   </label>
                 </div>
                 {/**/}
                 {/**/}
               </div>

               {/**/}
             </div>
             <div className="col-xs-12 pad0 subMsgActions">
               <button
                 className="primaryBtn msgActionBtn"
                 id="sendEnqiryButton"
                 type="submit"
                 ng-click="replyInboxMessage()"
               >
                 Send
               </button>
               <button
                 type="button"
                 name="Cancel"
                 className="cancelBtn msgActionBtn"
                 ng-click="cancelClik()"
               >
                 Cancel
               </button>
               <button className="primaryBtn msgActionBtn hide" type="button">
                 Reply
               </button>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>)},
  (props:{
   index:number, reply?: JSX.Element | null,
 setReplyStrValue?: (value: string) => void,

  }) => {
   const setReplyValue = props?.setReplyStrValue || (() => {
       console.log('setReplyValue not set')
    });
   return ( <motion.div

   key={
     props.index
   }
   initial="collapsed"
   animate="open"
   exit="collapsed"
   variants={{
     open: { opacity: 1, height: "auto" },
     collapsed: { opacity: 0, height: 0 },
   }}
   transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
   ng-if="changeIndex[$index]"
   className="panel-collapse collapse detiledMsgView  in"
   ng-class="(changeIndex[$index])?'panel-collapse collapse in ':'panel-collapse collapse '"
   style={{}}
 >
   <motion.div
     variants={{
       collapsed: {
         scaleY: 0.1,

         //expand from bottom to top
         originY: 0,
       },
       open: {
         scaleY: 1,
         //expand from top to bottom
         originY: 0,
       },
     }}
     transition={{
       duration: 1.8,

       ease: [0.04, 0.62, 0.23, 0.98],

       type: "spring",
       stiffness: 100,
       damping: 11,
       mass: 3,
     }}
     className="panel-body "
   >
     <div className="col-xs-12 detailedMsg">
       <div className="col-xs-12 pad0 text-right padB15">
         <a href="">
           {" "}
           <img
             src="images/print.png"
             alt="Print"
             className="printIcon"
             msg-print=""
             print-element-id="print_0"
           />
         </a>
       </div>
       <div id="print_0">
         {/* ng-click="printDiv('print_'+$index)" */}
         {/**/}
         <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
           {/**/}
           <div
             className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
             ng-if="messageFolderType =='Inbox'"
             ng-show="messageType"
           >
             {/**/}
             <p
               ng-repeat="body in smcMessage.bodies"
               ng-bind-html="body.content | newlines"
               className="healthReminder"
             >
               Dear Ziping Liu:
               <br />
               <br />
               Thank you for contacting us.
               <br />
               <br />
               Your coverage has ended <br />
               Our records show your coverage through Amazon.Com Services,
               Inc became effective from 12/18/2020 and ended on 08/31/2022.
               Our records show that your coverage was not reinstated until
               06/06/2023. <br /> <br />
               Changes needed <br />
               Please contact your benefits office if you think this
               information is incorrect. You can reach My HR Live Support at
               1-800-621-8041. They can contact our Employer Services
               department to make any needed changes.
               <br />
               <br />
               If there is anything else that we can assist you with, please
               let us know. We are happy to help you!
               <br />
               <br />
               If you have questions, use the 'Contact Us' link on the member
               website (to protect your confidential information). Or, you
               can call us toll-free at the number listed on your ID card.
               <br />
               <br />
               Sincerely,
               <br />
               Suraj N<br />
               Aetna Internet Response Team
               <br />
               50898500
               <br />
               <br />
               NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
               To view Aetna's privacy practices, please edit, copy and paste
               this website into your browser:
               https://www.aetna.com/legal-notices/privacy.html <br />
               <br />
               If you have questions about the Coronavirus, there are helpful
               resources online at CVS.com or copying and pasting this
               website into your browser:
               https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
               <br />
               <br />
               <br />
               *NA Concierge - Member - East
               <br />
               <br />
               <br />
               <br />
               Original Message Excluded:
               <br />
               -----------------------
               <br />
             </p>
             {/**/}
             <p
               ng-repeat="body in smcMessage.bodies"
               ng-bind-html="body.content | newlines"
               className="healthReminder"
             >
               {" "}
             </p>
             {/**/}
           </div>
           {/**/}
           {/**/}
           <div
             className="user1_msg_content row"
             ng-if="messageFolderType =='Inbox'"
             ng-hide="messageType"
             style={{ display: "none" }}
           >
             {/* commented as part of smcchanges Team B */}
             {/* <div class="col-md-2 text-right"></div> */}
             <div className="col-xs-12 pad0 padB15">
               <div className="col-xs-12 user_msg_box">
                 <div className="col-xs-12 padL0 padR0 padB15">
                   <strong>From: Member Services</strong>
                   {/**/}
                   <p
                     ng-repeat="body in smcMessage.bodies"
                     ng-bind-html="body.content | newlines"
                   >
                     Dear Ziping Liu:
                     <br />
                     <br />
                     Thank you for contacting us.
                     <br />
                     <br />
                     Your coverage has ended <br />
                     Our records show your coverage through Amazon.Com
                     Services, Inc became effective from 12/18/2020 and ended
                     on 08/31/2022. Our records show that your coverage was
                     not reinstated until 06/06/2023. <br /> <br />
                     Changes needed <br />
                     Please contact your benefits office if you think this
                     information is incorrect. You can reach My HR Live
                     Support at 1-800-621-8041. They can contact our Employer
                     Services department to make any needed changes.
                     <br />
                     <br />
                     If there is anything else that we can assist you with,
                     please let us know. We are happy to help you!
                     <br />
                     <br />
                     If you have questions, use the 'Contact Us' link on the
                     member website (to protect your confidential
                     information). Or, you can call us toll-free at the
                     number listed on your ID card.
                     <br />
                     <br />
                     Sincerely,
                     <br />
                     Suraj N<br />
                     Aetna Internet Response Team
                     <br />
                     50898500
                     <br />
                     <br />
                     NOTICE TO RECIPIENT(S) OF INFORMATION: <br />
                     To view Aetna's privacy practices, please edit, copy and
                     paste this website into your browser:
                     https://www.aetna.com/legal-notices/privacy.html <br />
                     <br />
                     If you have questions about the Coronavirus, there are
                     helpful resources online at CVS.com or copying and
                     pasting this website into your browser:
                     https://www.aetna.com/individuals-families/member-rights-resources/covid19.html
                     <br />
                     <br />
                     <br />
                     *NA Concierge - Member - East
                     <br />
                     <br />
                     <br />
                     <br />
                     Original Message Excluded:
                     <br />
                     -----------------------
                     <br />
                   </p>
                   {/**/}
                   <p
                     ng-repeat="body in smcMessage.bodies"
                     ng-bind-html="body.content | newlines"
                   >
                     {" "}
                   </p>
                   {/**/}
                   {/**/}
                   <div style={{ marginTop: "15px !important" }} />
                   {/**/}
                 </div>
               </div>
               <div className="col-xs-12 pad0 padT5">
                 <p className="text-right">
                   <span>06/06/2023</span>
                 </p>
               </div>
             </div>
             {/* Removed as part of SMC changes */}
             {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                       <img
                                         src="images/Communication_center_icons/User-1.png"
                                         alt="" class="padL15">
                                     </div> */}
           </div>
           {/**/}
           {/**/}
         </div>
         {/**/}
         <div ng-repeat="smcMessage in inboxMsgDetails.smcMessageList">
           {/**/}
           <div
             className="col-md-12 col-xs-12 detailedMsg healthReminder clearfix ng-hide"
             ng-if="messageFolderType =='Inbox'"
             ng-show="messageType"
             style={{
               display: "none",
             }}
           >
             {/**/}
             <p
               ng-repeat="body in smcMessage.bodies"
               ng-bind-html="body.content | newlines"
               className="healthReminder"
             >
               Details of Complaint: Explanation: Can you please let me know
               when my health insurance will become active? I am in the
               process of having this health insurance reactivate with
               Amazon.com. Can you take action on your end to ensure this is
               done by tomorrow?
               <br />
               Resolution Actions: Attempt to resolve the situation:{" "}
             </p>
             {/**/}
           </div>
           {/**/}
           {/**/}
           <div
             className="user1_msg_content row"
             ng-if="messageFolderType =='Inbox'"
             ng-hide="messageType"
             style={{
               display: "none",
             }}
           >
             {/* commented as part of smcchanges Team B */}
             {/* <div class="col-md-2 text-right"></div> */}
             <div className="col-xs-12 pad0 padB15">
               <div className="col-xs-12 user_msg_box">
                 <div className="col-xs-12 padL0 padR0 padB15">
                   <strong>From: ZIPING LIU</strong>
                   {/**/}
                   <p
                     ng-repeat="body in smcMessage.bodies"
                     ng-bind-html="body.content | newlines"
                   >
                     Details of Complaint: Explanation: Can you please let me
                     know when my health insurance will become active? I am
                     in the process of having this health insurance
                     reactivate with Amazon.com. Can you take action on your
                     end to ensure this is done by tomorrow?
                     <br />
                     Resolution Actions: Attempt to resolve the situation:{" "}
                   </p>
                   {/**/}
                   {/**/}
                   <div style={{ marginTop: "15px !important" }} />
                   {/**/}
                 </div>
               </div>
               <div className="col-xs-12 pad0 padT5">
                 <p className="text-right">
                   <span>06/04/2023</span>
                 </p>
               </div>
             </div>
             {/* Removed as part of SMC changes */}
             {/* <div class="col-md-2 col-xs-3 text-left user_img">
                                       <img
                                         src="images/Communication_center_icons/User-1.png"
                                         alt="" class="padL15">
                                     </div> */}
           </div>
           {/**/}
           {/**/}
         </div>
         {/**/}
       </div>
       <div
         className="modal fade contact-modal"
         id="contact-popup-reply"
         role="dialog"
         aria-labelledby="contact-confirmation"
       >
         <div className="modal-dialog">
           {/* Modal content*/}
           <div className="modal-content">
             <div className="modal-header text-center">
               <h4 className="modal-title" id="contact-confirmation">
                 Alert
               </h4>
             </div>
             <div className="modal-body" id="popUpBody">
               <p
                 ng-bind-html="popUpMessage"
                 style={{ overflowWrap: "break-word" }}
               >
                 Upload failed. Please try again. If the issue persists,
                 contact member services.
               </p>
             </div>
             <div className="modal-footer">
               <div>
                 <button
                   type="submit"
                   className="primaryBtn"
                   ng-click="popUpCloseReply('Ok')"
                 >
                   Yes
                 </button>
                 <button
                   className="cancelBtn"
                   type="button"
                   style={{ marginLeft: 15 }}
                   ng-click="popUpCloseReply('')"
                 >
                   No
                 </button>
               </div>
             </div>
             <button type="button" className="close" data-dismiss="modal">
               <img
                 src="images/close.png"
                 className="close"
                 alt="Close"
                 ng-click="popUpCloseReply('')"
               />
             </button>
           </div>
         </div>
       </div>

       <div
         className="col-xs-12 padT15 submsgContent ng-pristine ng-valid ng-valid-maxlength"
         ng-form="replyForm"
         ng-show="!(isReply)"
         style={{}}
       >
         <div className="col-xs-12 pad0 form-group">
           <label htmlFor="subMsg" className="control-label sr-only">
             New sub message
           </label>
           {/* <textarea
   id="subMsg"
   type="text"
   name="yourMessage"
   rows={4}
   className="marT15 marB15 form-control ng-pristine ng-valid ng-empty ng-valid-maxlength ng-touched"
   placeholder="Enter your message here"
   ng-model="inputMsg.text"
   maxLength={1000}
   cols={50}
   ng-change="validateInputMsg()"
   style={{}}
   defaultValue={
     "\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
   }
 /> */}
           {/* <EditorProvider
 
 >
 <Editor
     className="marT15 marB15 form-control ng-pristine ng-valid ng-empty ng-valid-maxlength ng-touched"

     id= "subMsg"
     ng-model="inputMsg.text"
   value={replyValue ||''}
   onChange={(e)=> {
     if(setReplyValue){
       setReplyValue(e.target.value)
     }
   }}
   >
     <Toolbar></Toolbar>
   </Editor></EditorProvider>
    */}
           <RichTextEditorComponent
 onChange={
   (e: any)=> {
     console.log('change',e)
   }
 }
 onBlur={(e)=> {
   //@ts-ignore


   if(setReplyValue){

     console.info('setting innert html', e.target.innerHTML?.length);
     setReplyValue(e.target.innerHTML);


     }
 }}
 showTooltip={true}
           >
             
{
 props.reply || (<p>
   Where the fuck?
 </p>)
}
             <Inject services={[Toolbar, HtmlEditor]} />
           </RichTextEditorComponent>

           <div ng-show="sendChk" className="ng-hide">
             <span className="error">Message cannot be blank.</span>
           </div>
           <div className="col-xs-12 pad0">
             {/**/}
             <div
               className="cont-cliamsrt uploadAttachment row"
               ng-if="isFileUpload"
             >
               <div className="form-group clearfix form-group clearfix  ">
                 <div className="col-sm-4 ">
                   <label
                     htmlFor="fileuploadlist"
                     className="paddlr30 btn anchor bold btn-default btn-file"
                     ng-class="{ 'btn-file': (((uploadFiles.length)<5) && (totalSizeFile<5242880)),'btn-file-disable':(((uploadFiles.length)>=5) || (totalSizeFile>5242880)||(fileCount>=5))}"
                   >
                     Upload attachment(s)
                     <input
                       type="file"
                       id="fileuploadlist"
                       name="Upload attachment(s)"
                       ng-disabled="(((uploadFiles.length)==5) || (totalSizeFile>5242880))"
                       data-multiple="true"
                       custom-on-change="fileslistdemo"
                       style={{ display: "none" }}
                     />
                   </label>
                   <button
                     className="btn btn--primary col-full"
                     onClick={(e: any) => {
                      
                      e.preventDefault();

                    

                      previewFile({
                        _fileMeta: {
                          fileName: 'NOTICE_OF_ABUSE_AND_NEGLECT_BY_AMAZONDLS.pdf'
                        },
                        divId:'exhibit-f-pdf',
                        url:"https://storage.googleapis.com/laotzu/awslegal/ANDYTIME/FMLA_JUNE11_L029%20-%20Approval%20-%20EOHC%20-%20EE-04073256.pdf",
                        clientID: clientId(),
                      
                        viewerConfig:{
                          embedMode: 'LIGHT_BOX',
                        }
                      })
                     }}
                   >
                     <img
                       src="https://member.aetna.com/secure/member/images/Communication_center_icons/PDF.png"
                       alt=""
                       className="padR15"
                       ng-show="isPDFFile(attach.name)"
                     />

                     <span
                       style={{
                         color: "purple",
                       }}
                     >
                       {" "}
                       NOTICE_OF_ABUSE_AND_NEGLECT_BY_AMAZONDLS.pdf
                     </span>
                   </button>
                 </div>
                 <label className="col-sm-8">
                   {" "}
                   <span>Add up to 5 files, total of 5 MB</span>
                 </label>
               </div>
               {/**/}
               {/**/}
             </div>

             {/**/}
           </div>
           <div className="col-xs-12 pad0 subMsgActions">
             <button
               className="primaryBtn msgActionBtn"
               id="sendEnqiryButton"
               type="submit"
               onClick={undefined}
             >
               Send
             </button>
             <button
               type="button"
               name="Cancel"
               className="cancelBtn msgActionBtn"
               onClick={undefined}
             >
               Cancel
             </button>
             <button
               onClick={undefined}
               className="primaryBtn msgActionBtn hide"
               type="button"
             >
               Reply
             </button>
           </div>
         </div>
       </div>
     </div>

   </motion.div>
 </motion.div>)
  }
 ]
 export const getDate = (index:number) => {
  const JSXElement = Jreturn[index](
    {
      index: index,
    }
  );
  const createRoot = document.createElement("div");

  const root = ReactDOM.createPortal(JSXElement, createRoot);

  
  const span = createRoot.querySelector("span.col-xs-12.pad0.padT5");
  if (span) {
    const date = (span as HTMLElement).innerText;
    return date;
  }
  return "";
};

export default function JsxMessages(props: {
  index?: number;
  reply?: JSX.Element | null,
 setReply?: (val: string) => void,
  
  setRteObject?: (val: RichTextEditorComponent) => void;
  rteObject?: RichTextEditorComponent;
}) {
  const index = props.index || 0;





  //get date from JSXElment, of the Jreturn element inside the array, with the span col-xs-12 pad0 padT5


  

  return(
    Jreturn[index]({
      index: index,
      reply: props.reply,
      setReplyStrValue: props.setReply
    })
  )


}
